<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content p-0">
          <!-- Header compacto con botones -->
          <div class="min-vh-100">
            <nav class="traffic-os-header">
              <div class="traffic-os-header-inner">
                <div class="d-flex align-items-center">
                  <div class="traffic-os-logo">
                    <i class="fas fa-shield-alt"></i>
                    <span class="traffic-os-logo-p"></span>
                  </div>
                  <span class="traffic-os-brand">Central de Tráfico</span>
                </div>
                <div class="d-flex align-items-center traffic-os-actions">
                  <button
                    v-if="mostrarUltimasNovedades"
                    type="button"
                    class="btn btn-link"
                    title="Buscar"
                    @click="mostrarFiltros = !mostrarFiltros"
                  >
                    <i class="fas fa-search"></i>
                    <span class="d-none d-md-inline ml-1">Buscar</span>
                  </button>
                  <!-- Exportar Novedades -->
                  <button
                    class="btn btn-link"
                    title="Exportar a Excel"
                    data-toggle="modal"
                    data-target="#modalExportar-novedades"
                    @click="limpiarFiltrosExportar"
                  >
                    <i class="fas fa-file-excel"></i>
                    <span class="d-none d-md-inline ml-1"
                      >Exportar Novedades</span
                    >
                  </button>
                  <!-- Botón de sonido -->
                  <button
                    class="btn btn-link"
                    :class="
                      sonidoActivo && audioHabilitado
                        ? 'btn-dark'
                        : 'btn-outline-secondary'
                    "
                    @click="toggleSonido"
                    :title="
                      sonidoActivo
                        ? audioHabilitado
                          ? 'Sonido activado'
                          : 'Clic para activar sonido'
                        : 'Sonido desactivado'
                    "
                  >
                    <i
                      class="fas"
                      :class="
                        sonidoActivo && audioHabilitado
                          ? 'fa-volume-up'
                          : 'fa-volume-mute'
                      "
                    ></i>
                    Sonido
                  </button>
                  <!-- Botón de Menu -->
                  <div
                    class="btn-group dropdown"
                    style="position: relative; z-index: 10000"
                    ref="menuDropdownRef"
                  >
                    <button
                      type="button"
                      class="btn btn-link"
                      aria-haspopup="true"
                      :aria-expanded="menuDropdownOpen"
                      @click.stop="menuDropdownOpen = !menuDropdownOpen"
                    >
                      <i class="fas fa-bars"></i>
                      <span class="d-none d-md-inline ml-1">Menu</span>
                    </button>
                    <div
                      class="dropdown-menu dropdown-menu-right"
                      :class="{ show: menuDropdownOpen }"
                      style="
                        z-index: 10000;
                        min-width: 80px;
                        right: 0;
                        left: auto;
                      "
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="irAVista('ultimasNovedades')"
                      >
                        <i class="fas fa-bell"></i>
                        Últimas Novedades
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="irAVista('novedadesServicios')"
                      >
                        <i class="fas fa-exclamation-triangle"></i>
                        Novedades
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="irAVista('gestionTif')"
                      >
                        <i class="fas fa-truck-loading"></i>
                        Transporte Interno Fluidos
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="irAVista('gestionTep')"
                      >
                        <i class="fas fa-truck"></i>
                        Transporte Especial
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="irAVista('gestionPlantExterna')"
                      >
                        <i class="fas fa-industry"></i>
                        Planta Externa
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="irAVista('mapaCalor')"
                      >
                        <i class="fas fa-fire"></i>
                        Mapa Calor
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
            <!-- Vista: Últimas Novedades -->
            <div v-show="mostrarUltimasNovedades">
              <!-- Filtros Bootstrap (ocultos en tiempo real) -->
              <div
                class="px-3 px-md-4 mx-auto mb-2"
                style="max-width: 1400px"
                v-show="mostrarFiltros"
              >
                <div class="card mt-2 mb-0">
                  <div
                    class="card-header bg-gray px-3 py-2"
                    @click="mostrarFiltros = !mostrarFiltros"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <div
                          class="bg-white bg-opacity-20 rounded-circle px-2 py-1"
                        >
                          <i class="fas fa-filter mt-1"></i>
                        </div>
                        <div>
                          <h5 class="mb-1 fw-bold text-white ml-2">
                            Filtros de Búsqueda
                          </h5>
                          <p class="mb-0 small text-white-50 ml-2">
                            Personaliza tu búsqueda de novedades
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body px-3 px-md-4">
                    <div class="row g-3 mb-4 justify-content-center">
                      <!-- Tipo Novedad -->
                      <div class="col-md-6 col-lg-4">
                        <div class="card h-100">
                          <div class="card-body">
                            <label
                              class="form-label d-flex align-items-center mb-2"
                            >
                              <div
                                class="bg-warning text-white rounded-circle p-1 me-2"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <i
                                  class="fas fa-exclamation-triangle"
                                  style="font-size: 0.75rem"
                                ></i>
                              </div>
                              <span class="fw-semibold ml-1"
                                >Tipo de Novedad</span
                              >
                            </label>
                            <v-select
                              v-model="filtros.tipo_novedad"
                              :options="listasForms.tiposNovedad"
                              label="descripcion"
                              :reduce="(tipo) => tipo.numeracion"
                              placeholder="Seleccionar tipo..."
                              clearable
                              class="form-select"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- Tipo SubNovedad -->
                      <div class="col-md-6 col-lg-4">
                        <div class="card h-100">
                          <div class="card-body">
                            <label
                              class="form-label d-flex align-items-center mb-2"
                            >
                              <div
                                class="bg-warning text-white rounded-circle p-1 me-2"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <i
                                  class="fas fa-exclamation-triangle"
                                  style="font-size: 0.75rem"
                                ></i>
                              </div>
                              <span class="fw-semibold ml-1"
                                >Tipo de SubNovedad</span
                              >
                            </label>
                            <v-select
                              v-model="filtros.tipo_subnovedad"
                              :options="
                                filtros.tipo_novedad == 1
                                  ? listasForms.subNovedadesGps
                                  : filtros.tipo_novedad == 2
                                  ? listasForms.subNovedadesRutas
                                  : filtros.tipo_novedad == 3
                                  ? []
                                  : listasForms.subNovedadesGeocercas
                              "
                              label="descripcion"
                              :reduce="(sub) => sub.numeracion"
                              placeholder="Seleccionar tipo..."
                              clearable
                              class="form-select"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- Relevancia -->
                      <div class="col-md-6 col-lg-4">
                        <div class="card h-100">
                          <div class="card-body">
                            <label
                              class="form-label d-flex align-items-center mb-2"
                            >
                              <div
                                class="bg-info text-white rounded-circle p-1 me-2"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <i
                                  class="fas fa-signal"
                                  style="font-size: 0.75rem"
                                ></i>
                              </div>
                              <span class="fw-semibold ml-1"
                                >Nivel de Relevancia</span
                              >
                            </label>
                            <v-select
                              v-model="filtros.relevancia"
                              :options="listasForms.relevancias"
                              label="descripcion"
                              :reduce="(relevancia) => relevancia.numeracion"
                              placeholder="Seleccionar relevancia..."
                              clearable
                              class="form-select"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- Cantidad por Página -->
                      <div class="col-md-6 col-lg-4">
                        <div class="card h-100">
                          <div class="card-body">
                            <label
                              class="form-label d-flex align-items-center mb-2"
                            >
                              <div
                                class="bg-primary text-white rounded-circle p-1 me-2"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <i
                                  class="fas fa-list-ol"
                                  style="font-size: 0.75rem"
                                ></i>
                              </div>
                              <span class="fw-semibold ml-1"
                                >Cantidad por Página</span
                              >
                            </label>
                            <v-select
                              v-model="filtros.per_page"
                              :options="[
                                { value: 10, label: '10 registros' },
                                { value: 25, label: '25 registros' },
                                { value: 50, label: '50 registros' },
                                { value: 100, label: '100 registros' },
                              ]"
                              label="label"
                              :reduce="(option) => option.value"
                              placeholder="Seleccionar cantidad..."
                              class="form-select"
                              @input="onCantidadChange"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- Tipo de Filtro -->
                      <div class="col-md-6 col-lg-4 mt-2">
                        <div class="card h-100">
                          <div class="card-body">
                            <label
                              class="form-label d-flex align-items-center mb-2"
                            >
                              <div
                                class="bg-primary text-white rounded-circle p-1 me-2"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <i
                                  class="fas fa-filter"
                                  style="font-size: 0.75rem"
                                ></i>
                              </div>
                              <span class="fw-semibold ml-1"
                                >Tipo de Filtro</span
                              >
                            </label>
                            <v-select
                              v-model="filtros.tipo_filtro"
                              :options="[
                                { value: '1', label: 'Tep Viajes' },
                                { value: '2', label: 'Tif Turno' },
                                { value: '3', label: 'Tep Turno' },
                              ]"
                              label="label"
                              :reduce="(option) => option.value"
                              placeholder="Seleccionar tipo..."
                              clearable
                              class="form-select"
                              @input="getIndex()"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- ID Entidad-->
                      <div class="col-md-6 col-lg-4 mt-2">
                        <div class="card h-100">
                          <div class="card-body">
                            <label
                              class="form-label d-flex align-items-center mb-2"
                            >
                              <div
                                class="bg-primary text-white rounded-circle p-1 me-2"
                                style="
                                  width: 24px;
                                  height: 24px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                              >
                                <i
                                  class="fas fa-route"
                                  style="font-size: 0.75rem"
                                ></i>
                              </div>
                              <span class="fw-semibold ml-1">#Servicio</span>
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-primary text-white"
                              >
                                <i class="fas fa-hashtag"></i>
                              </span>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                v-model="filtros.entidad_id"
                                placeholder="Ej: 12345"
                                @input="getIndex()"
                                :disabled="!filtros.tipo_filtro"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Botones de acción rápida -->
                    <div class="card-body">
                      <div
                        class="d-flex flex-wrap gap-2 justify-content-center"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-primary px-3"
                          @click="getIndex()"
                          :disabled="cargando"
                        >
                          <i
                            class="fas fa-search me-2"
                            :class="cargando ? 'fa-spin' : ''"
                          ></i>
                          {{ cargando ? "Buscando..." : "Buscar Novedades" }}
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-danger"
                          @click="limpiarFiltros"
                          :disabled="cargando"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-warning"
                          @click="(filtros.relevancia = 2), getIndex()"
                          :disabled="cargando"
                        >
                          <i class="fas fa-exclamation-triangle me-1"></i>
                          Solo Emergencias
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Contenido principal -->
              <div
                class="row g-2 pt-2 px-3 px-md-3 mx-auto"
                style="max-width: 1400px"
              >
                <!-- Mapa -->
                <div class="col-md-8">
                  <div class="card shadow-sm h-100">
                    <div class="card-body p-0 position-relative">
                      <div
                        v-if="cargando || cargandoMapa"
                        class="text-center p-3"
                        style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          z-index: 1000;
                        "
                      >
                        <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
                        <p class="mt-2 text-muted small">Cargando mapa...</p>
                      </div>
                      <gmap-map
                        ref="mapRef"
                        class="w-100 border border-default"
                        style="height: 600px; min-height: 300px"
                        :center="mapCenter"
                        :zoom="mapZoom"
                        :options="mapOptions"
                        @click="onMapClick"
                      >
                        <gmap-marker
                          v-for="(marker, index) in markersNovedades"
                          :key="index"
                          :position="marker.position"
                          :icon="marker.icon"
                          :clickable="true"
                          @click="toggleInfoWindow(marker, index)"
                        ></gmap-marker>

                        <gmap-polyline
                          v-for="(polyline, index) in polylines"
                          :key="'polyline-' + index"
                          :path="polyline.path"
                          :options="{
                            strokeColor: polyline.strokeColor,
                            strokeOpacity: polyline.strokeOpacity,
                            strokeWeight: polyline.strokeWeight,
                          }"
                        />

                        <gmap-info-window
                          :options="infoWindowOptions"
                          :position="infoWindowPosition"
                          :opened="infoWindowOpen"
                          @closeclick="infoWindowOpen = false"
                        >
                          <div v-html="infoWindowContent"></div>
                        </gmap-info-window>
                      </gmap-map>
                    </div>
                  </div>
                </div>
                <!-- Panel de Novedades Compacto -->
                <div class="col-md-4">
                  <div class="card shadow-sm h-100">
                    <div
                      class="card-header bg-gradient-primary text-white py-2"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="fas fa-bell me-2"></i>
                          <h6 class="mb-0">Novedades</h6>
                        </div>
                        <span
                          class="badge bg-white text-primary px-2 py-1"
                          v-if="novedades.length"
                          >Total:
                          {{ novedades.length }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="card-body p-0"
                      style="max-height: 500px; overflow-y: auto"
                    >
                      <div v-if="cargando" class="text-center p-3">
                        <div class="mb-2">
                          <i
                            class="fas fa-spinner fa-spin fa-2x text-primary"
                          ></i>
                        </div>
                        <h6 class="text-muted mb-1" style="font-size: 0.85rem">
                          Cargando novedades...
                        </h6>
                        <small class="text-muted" style="font-size: 0.7rem">
                          Buscando información en tiempo real
                        </small>
                      </div>
                      <div
                        v-else-if="novedades.length === 0"
                        class="text-center p-3"
                      >
                        <div class="mb-2">
                          <i class="fas fa-bell-slash fa-2x text-muted"></i>
                        </div>
                        <h6 class="text-muted mb-1" style="font-size: 0.85rem">
                          No hay novedades
                        </h6>
                        <small class="text-muted" style="font-size: 0.7rem">
                          No se encontraron novedades con los filtros aplicados
                        </small>
                        <div class="mt-2">
                          <button
                            class="btn btn-outline-primary btn-sm"
                            @click="limpiarFiltros"
                            style="font-size: 0.75rem"
                          >
                            <i class="fas fa-eraser me-1"></i>
                            Limpiar Filtros
                          </button>
                        </div>
                      </div>
                      <div class="p-2" v-else>
                        <div
                          v-for="novedad in novedades"
                          :key="novedad.id"
                          class="border rounded mb-2 p-2 position-relative shadow-sm"
                          style="cursor: pointer; transition: all 0.2s ease"
                          @click="seleccionarNovedad(novedad)"
                          :class="{
                            'border-primary bg-light':
                              novedadSeleccionada &&
                              novedadSeleccionada.id === novedad.id,
                            'border-default': !(
                              novedadSeleccionada &&
                              novedadSeleccionada.id === novedad.id
                            ),
                          }"
                        >
                          <!-- Header compacto -->
                          <div class="d-flex align-items-center mb-2">
                            <div
                              class="rounded-circle d-flex align-items-center justify-content-center me-2"
                              style="width: 28px; height: 28px"
                              :class="{
                                'bg-warning text-white':
                                  novedad.relevancia === 1,
                                'bg-danger text-white':
                                  novedad.relevancia === 2,
                                'bg-info text-white': novedad.relevancia === 3,
                                'bg-secondary text-white': !novedad.relevancia,
                              }"
                            >
                              <i
                                class="fas"
                                :class="getNovedadIcon(novedad.tipo_novedad)"
                                style="font-size: 0.75rem"
                              ></i>
                            </div>
                            <div class="flex-grow-1">
                              <h6
                                class="mb-0 fw-bold text-dark ml-1"
                                style="font-size: 0.85rem"
                              >
                                {{ novedad.nTipoNovedad || "N/A" }}
                              </h6>
                              <small
                                class="text-muted ml-1"
                                style="font-size: 0.7rem"
                              >
                                <i class="far fa-clock me-1"></i>
                                {{ formatFecha(novedad.fecha_novedad) }}
                              </small>
                            </div>
                            <span
                              class="badge"
                              :class="getRelevanciaColor(novedad.relevancia)"
                              style="font-size: 0.65rem"
                            >
                              {{ novedad.nRelevancia || "N/A" }}
                            </span>
                          </div>

                          <!-- Información compacta en grid -->
                          <div class="row g-1 mb-2">
                            <div class="col-6">
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-truck text-primary me-1"
                                  style="font-size: 0.7rem"
                                ></i>
                                <span
                                  class="text-muted small ml-1"
                                  style="font-size: 0.7rem"
                                  >Vh:</span
                                >
                                <strong
                                  class="ml-1"
                                  style="font-size: 0.7rem"
                                  >{{ getPlacaVehiculo(novedad) }}</strong
                                >
                              </div>
                            </div>
                            <div class="col-6" v-if="getRemolque(novedad)">
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-trailer text-warning"
                                  style="font-size: 0.7rem"
                                ></i>
                                <span
                                  class="text-muted small ml-1"
                                  style="font-size: 0.7rem"
                                  >Rem:</span
                                >
                                <strong
                                  class="ml-1"
                                  style="font-size: 0.7rem"
                                  >{{ getRemolque(novedad) || "N/A" }}</strong
                                >
                              </div>
                            </div>
                            <div class="col-6" v-if="novedad.velocidad">
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-tachometer-alt text-warning"
                                  style="font-size: 0.7rem"
                                ></i>
                                <span
                                  class="text-muted small ml-1"
                                  style="font-size: 0.7rem"
                                  >Vel:</span
                                >
                                <strong class="ml-1" style="font-size: 0.7rem"
                                  >{{ novedad.velocidad }} km/h</strong
                                >
                              </div>
                            </div>
                            <div
                              class="col-6"
                              v-if="getTipoSubNovedad(novedad)"
                            >
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-tag text-muted me-1"
                                  style="font-size: 0.7rem"
                                ></i>
                                <span
                                  class="badge bg-light text-dark"
                                  style="font-size: 0.65rem"
                                  >{{ getTipoSubNovedad(novedad) }}</span
                                >
                              </div>
                            </div>
                          </div>

                          <!-- Conductor compacto -->
                          <div
                            class="bg-light border border-default p-2 rounded mb-2"
                            v-if="getConductor(novedad)"
                          >
                            <div
                              class="d-flex align-items-center justify-content-center mb-1"
                            >
                              <i
                                class="fas fa-user text-info"
                                style="font-size: 0.7rem"
                              ></i>
                              <strong
                                class="text-dark ml-1"
                                style="font-size: 0.75rem"
                                >{{ getConductor(novedad) }}</strong
                              >
                            </div>
                            <div class="row g-1">
                              <div class="col-6 d-flex align-items-center">
                                <i class="fas fa-id-card"></i>
                                <small
                                  class="text-muted ml-1"
                                  style="font-size: 0.65rem"
                                >
                                  {{ getConductorDocumento(novedad) || "N/A" }}
                                </small>
                              </div>
                              <div class="col-6 d-flex align-items-center">
                                <i class="fas fa-phone"></i>
                                <small
                                  class="text-muted ml-1"
                                  style="font-size: 0.65rem"
                                >
                                  {{ getConductorCelular(novedad) || "N/A" }}
                                </small>
                              </div>
                            </div>
                          </div>

                          <!-- Ubicación compacta -->
                          <div
                            class="alert-default-warning border border-default bg-opacity-10 p-2 rounded"
                            v-if="novedad.latitud && novedad.longitud"
                          >
                            <div class="d-flex align-items-center mb-1">
                              <i
                                class="fas fa-map-marker-alt text-danger me-1"
                                style="font-size: 0.7rem"
                              ></i>
                              <span
                                class="text-muted small ml-1"
                                style="font-size: 0.7rem"
                                >Ubicación</span
                              >
                            </div>
                            <div class="row g-1">
                              <div class="col-6">
                                <small
                                  class="badge bg-light text-dark w-100 text-center"
                                  style="font-size: 0.6rem"
                                >
                                  Lat:
                                  {{ parseFloat(novedad.latitud).toFixed(3) }}
                                </small>
                              </div>
                              <div class="col-6">
                                <small
                                  class="badge bg-light text-dark w-100 text-center"
                                  style="font-size: 0.6rem"
                                >
                                  Lng:
                                  {{ parseFloat(novedad.longitud).toFixed(3) }}
                                </small>
                              </div>
                            </div>
                            <div class="mt-1" v-if="novedad.direccion">
                              <small
                                class="text-muted"
                                style="font-size: 0.65rem"
                              >
                                <i class="fas fa-road"></i>
                                {{
                                  novedad.direccion.length > 30
                                    ? novedad.direccion.substring(0, 30) + "..."
                                    : novedad.direccion
                                }}
                              </small>
                            </div>
                            <div
                              class="mt-1"
                              v-if="
                                novedad.det_tramo_ruta &&
                                  novedad.det_tramo_ruta.tramo_ruta
                              "
                            >
                              <small
                                class="text-muted"
                                style="font-size: 0.65rem"
                              >
                                <i class="fas fa-route"></i>
                                Tramo:
                                {{ novedad.det_tramo_ruta.tramo_ruta.nombre }}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tabla de Novedades compacta -->
              <div class="row g-2 pt-2 px-md-4 mx-auto">
                <div class="card mb-0 mt-2 border border-default col-md-12">
                  <div class="card-header bg-default text-dark py-2">
                    <h6 class="mb-0" style="font-size: 0.9rem">
                      <i class="fas fa-table me-2"></i>
                      Tabla de Novedades
                    </h6>
                  </div>
                  <div class="card-body p-0">
                    <div v-if="cargando" class="text-center p-3">
                      <div class="mb-2">
                        <i
                          class="fas fa-spinner fa-spin fa-2x text-primary"
                        ></i>
                      </div>
                      <h6 class="text-muted mb-1" style="font-size: 0.85rem">
                        Cargando novedades...
                      </h6>
                      <small class="text-muted" style="font-size: 0.7rem">
                        Buscando información en tiempo real
                      </small>
                    </div>
                    <div class="table-responsive">
                      <table
                        class="table table-striped table-hover mb-0 text-nowrap table-bordered"
                      >
                        <thead class="table-dark">
                          <tr>
                            <th class="text-center">#</th>
                            <th>Tipo</th>
                            <th>ID</th>
                            <th>Transportadora</th>
                            <th>Vehículo</th>
                            <th>Conductor</th>
                            <th>Remolque</th>
                            <th>Tipo Novedad</th>
                            <th>Subnovedad</th>
                            <th>Relevancia</th>
                            <th>Fecha Novedad</th>
                            <th>Ubicación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(novedad, index) in novedadesPag.data"
                            :key="novedad.id"
                            class="align-middle"
                          >
                            <td class="text-center">
                              <span class="badge bg-secondary">{{
                                index + 1
                              }}</span>
                            </td>
                            <td>
                              <span
                                class="badge"
                                :class="
                                  novedad.entidad_type == 'App\\TepViajes'
                                    ? 'bg-primary'
                                    : novedad.entidad_type == 'App\\TifTurno'
                                    ? 'bg-success'
                                    : 'bg-info'
                                "
                              >
                                {{
                                  novedad.entidad_type == "App\\TepViajes"
                                    ? "Tep Viajes"
                                    : novedad.entidad_type == "App\\TifTurno"
                                    ? "Tif Turno"
                                    : novedad.entidad_type == "App\\TepTurno"
                                    ? "Tep Turno"
                                    : "N/A"
                                }}
                              </span>
                            </td>
                            <td>
                              <strong class="text-primary">{{
                                novedad.entidad_id || "N/A"
                              }}</strong>
                            </td>
                            <td>
                              {{ getEmpresa(novedad) }}
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <span>{{ getPlacaVehiculo(novedad) }}</span>
                              </div>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <span>{{ getConductor(novedad) }}</span>
                              </div>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <span>{{ getRemolque(novedad) || "N/A" }}</span>
                              </div>
                            </td>
                            <td>
                              <span class="fw-semibold">{{
                                novedad.nTipoNovedad || "N/A"
                              }}</span>
                            </td>
                            <td>
                              <span class="badge bg-light text-dark">{{
                                getTipoSubNovedad(novedad) || "N/A"
                              }}</span>
                            </td>
                            <td>
                              <span
                                class="badge"
                                :class="getRelevanciaColor(novedad.relevancia)"
                              >
                                {{ novedad.nRelevancia || "N/A" }}
                              </span>
                            </td>
                            <td>
                              <small class="text-muted">{{
                                novedad.fecha_novedad
                              }}</small>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-map-marker-alt text-danger"
                                ></i>
                                <small class="text-muted ml-1">{{
                                  novedad.direccion || "Sin dirección"
                                }}</small>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Paginación compacta -->
                  <div class="card-footer bg-light pb-0" v-if="!cargando">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <div
                          v-if="novedadesPag.total"
                          class="text-muted"
                          style="font-size: 0.8rem"
                        >
                          <i class="fas fa-info-circle me-1"></i>
                          Mostrando del
                          <strong>{{ novedadesPag.from }}</strong> al
                          <strong>{{ novedadesPag.to }}</strong> de un total:
                          <strong>{{ novedadesPag.total }}</strong> Registros
                        </div>
                        <div class="pb-2" v-else>
                          <span
                            class="badge bg-danger"
                            style="font-size: 0.75rem"
                          >
                            <i class="fas fa-exclamation-triangle me-1"></i>
                            No hay registros para mostrar
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="d-flex justify-content-end">
                          <pagination
                            :data="novedadesPag"
                            @pagination-change-page="getIndex"
                            :limit="5"
                            class="float-right"
                          ></pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal de Exportar -->
              <div
                class="modal fade"
                tabindex="-1"
                id="modalExportar-novedades"
              >
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content border-0 shadow-lg">
                    <div class="modal-header bg-geogo-top-left pt-2 pb-2">
                      <h4 class="modal-title text-white">Exportar Novedades</h4>
                      <button
                        type="button"
                        class="close text-white"
                        data-dismiss="modal"
                        aria-label="Close"
                        ref="modalExportar-novedades"
                        id="close-modal"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body p-4">
                      <div class="row g-3">
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-body">
                              <label
                                class="form-label d-flex align-items-center mb-3"
                              >
                                <span class="fw-semibold">Fecha Inicial</span>
                              </label>
                              <input
                                type="date"
                                class="form-control"
                                v-model="filtrosExportar.fecha_inicial"
                                :max="fechaMaxima"
                                :class="
                                  $v.filtrosExportar.fecha_inicial.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                @blur="valFechasExportar"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-body">
                              <label
                                class="form-label d-flex align-items-center mb-3"
                              >
                                Fecha Final
                              </label>
                              <input
                                type="date"
                                class="form-control"
                                v-model="filtrosExportar.fecha_final"
                                :max="fechaMaxima"
                                :class="
                                  $v.filtrosExportar.fecha_final.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                                @blur="valFechasExportar"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row g-3 mt-2">
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-body">
                              <label
                                class="form-label d-flex align-items-center mb-3"
                              >
                                Tipo de Novedad
                              </label>
                              <v-select
                                v-model="filtrosExportar.tipo_novedad"
                                :options="listasForms.tiposNovedad"
                                label="descripcion"
                                :reduce="(tipo) => tipo.numeracion"
                                placeholder="Seleccionar tipo..."
                                class="form-select"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-body">
                              <label
                                class="form-label d-flex align-items-center mb-3"
                              >
                                Tipo Sub Novedad
                              </label>
                              <v-select
                                v-if="filtrosExportar.tipo_novedad"
                                v-model="filtrosExportar.tipo_subnovedad"
                                :options="
                                  filtrosExportar.tipo_novedad == 1
                                    ? listasForms.subNovedadesGps
                                    : filtrosExportar.tipo_novedad == 2
                                    ? listasForms.subNovedadesRutas
                                    : listasForms.subNovedadesGeocercas
                                "
                                label="descripcion"
                                :reduce="(tipo) => tipo.numeracion"
                                placeholder="Seleccionar tipo..."
                                class="form-select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row g-3 mt-2">
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-body">
                              <label
                                class="form-label d-flex align-items-center mb-3"
                              >
                                Relevancia
                              </label>
                              <v-select
                                v-model="filtrosExportar.relevancia"
                                :options="listasForms.relevancias"
                                label="descripcion"
                                :reduce="(relevancia) => relevancia.numeracion"
                                placeholder="Seleccionar relevancia..."
                                class="form-select"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="card h-100">
                            <div class="card-body">
                              <label
                                class="form-label d-flex align-items-center mb-3"
                              >
                                Vehículo
                              </label>
                              <v-select
                                v-model="filtrosExportar.vehiculo_id"
                                @search="buscarVehiculos"
                                :options="listasForms.vehiculos"
                                label="placa"
                                :reduce="(vehiculo) => vehiculo.id"
                                placeholder="Seleccionar vehículo..."
                                class="form-select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="modal-footer bg-light"
                      v-if="!$v.filtrosExportar.$invalid"
                    >
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="exportarNovedades"
                        :disabled="exportando"
                      >
                        <i
                          class="fas me-1"
                          :class="
                            exportando ? 'fa-spinner fa-spin' : 'fa-file-excel'
                          "
                        ></i>
                        {{ exportando ? "Exportando..." : "Exportar" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Vista: Gestión TIF (componente) -->
            <div v-show="mostrarGestionTif" class="p-3">
              <GestionTif ref="gestionTif" />
            </div>
            <!-- Vista: Gestión TEP (componente) -->
            <div v-show="mostrarGestionTep" class="p-3">
              <GestionTep ref="gestionTep" />
            </div>
            <!-- Vista: Gestión Planta Externa (componente) -->
            <div v-show="mostrarGestionPlantExterna" class="p-3">
              <GestionPlantExterna ref="gestionPlantExterna" />
            </div>
            <!-- Vista: Gestión Novedades (componente) -->
            <div v-show="mostrarNovedadesServicios" class="p-3">
              <GestionNovedades ref="gestionNovedades" />
            </div>
            <!-- Vista: Mapa de Calor (componente) -->
            <div v-if="mostrarMapaCalor" class="p-3">
              <MapaCalorNovedades ref="mapaCalor" />
            </div>
          </div>
        </section>
      </div>
    </div>
    <SeguimientoNovedades ref="SeguimientoNovedades"></SeguimientoNovedades>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import GestionTif from "./GestionTif.vue";
import GestionTep from "./GestionTep.vue";
import pagination from "laravel-vue-pagination";
import { required } from "vuelidate/lib/validators";
import GestionNovedades from "./GestionNovedades.vue";
import GestionPlantExterna from "./GestionPlantExterna.vue";
import SeguimientoNovedades from "./SeguimientoNovedades.vue";
import MapaCalorNovedades from "./MapaCalorNovedades.vue";

export default {
  name: "TifCentralTraficoIndex",
  components: {
    vSelect,
    pagination,
    GestionTif,
    GestionTep,
    SeguimientoNovedades,
    GestionNovedades,
    GestionPlantExterna,
    MapaCalorNovedades,
  },
  data() {
    return {
      cargando: false,
      cargandoMapa: false,
      menuDropdownOpen: false,
      mostrarGestionTif: false,
      mostrarGestionTep: false,
      mostrarGestionPlantExterna: false,
      mostrarUltimasNovedades: true,
      mostrarNovedadesServicios: false,
      mostrarMapaCalor: false,
      novedades: [],
      novedadesPag: {},
      novedadSeleccionada: null,
      mostrarFiltros: true,
      sonidoActivo: false,
      audioHabilitado: false,
      exportando: false,

      //Lineas mapa
      tramosRutasMapa: [],
      polylines: [],

      // Filtros
      filtros: {
        tipo_novedad: null,
        tipo_subnovedad: null,
        relevancia: null,
        estado: null,
        per_page: 10,
        tipo_filtro: null,
        entidad_id: null,
      },

      filtrosExportar: {
        fecha_inicial: null,
        fecha_final: null,
        tipo_novedad: null,
        tipo_subnovedad: null,
        relevancia: null,
        vehiculo_id: null,
      },

      // Listas para formularios
      listasForms: {
        vehiculos: [],
        tiposNovedad: [],
        relevancias: [],
        subNovedadesGps: [],
        subNovedadesRutas: [],
        subNovedadesGeocercas: [],
      },

      // Mapa
      mapCenter: { lat: 4.6097, lng: -74.0817 }, // Bogotá por defecto
      mapZoom: 6,
      mapOptions: {
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
      },
      markersNovedades: [],
      infoWindowOpen: false,
      infoWindowPosition: null,
      infoWindowContent: "",
      infoWindowOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },

      // Computed properties helpers
      fechaMaxima: moment().format("YYYY-MM-DD"),
    };
  },
  validations: {
    filtrosExportar: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
    },
  },

  mounted() {
    this.cargarListas();
    this.getIndex();
    this.inicializarAudio();
    // Asegurar que el mapa se inicialice después de que el DOM esté listo
    this.$nextTick(() => {
      this.cargandoMapa = false;
    });
  },

  methods: {
    // Métodos de carga de datos
    async getIndex(page = 1) {
      this.cargando = true;
      try {
        const params = {
          page,
          per_page: this.filtros.per_page,
          ...this.filtros,
        };

        const response = await axios.get(
          "/api/tif/centralTrafico/ultNovedadesVhs?page=" + page,
          {
            params,
          },
        );
        this.novedades = response.data.data;
        this.novedadesPag = response.data.paginado;
        this.actualizarMarcadoresMapa();
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar las novedades",
        });
      } finally {
        this.cargando = false;
      }
    },

    cerrarMenuSiClickFuera(e) {
      if (
        this.menuDropdownOpen &&
        this.$refs.menuDropdownRef &&
        !this.$refs.menuDropdownRef.contains(e.target)
      ) {
        this.menuDropdownOpen = false;
      }
    },

    async irAVista(vista) {
      this.menuDropdownOpen = false;

      this.mostrarUltimasNovedades = false;
      this.mostrarGestionTif = false;
      this.mostrarGestionTep = false;
      this.mostrarGestionPlantExterna = false;
      this.mostrarNovedadesServicios = false;
      this.mostrarMapaCalor = false;

      switch (vista) {
        case "gestionTif":
          this.mostrarGestionTif = true;
          await this.$refs.gestionTif.cargarDatos();
          break;
        case "ultimasNovedades":
          this.mostrarUltimasNovedades = true;
          this.getIndex();
          break;
        case "gestionTep":
          this.mostrarGestionTep = true;
          await this.$refs.gestionTep.cargarDatos();
          break;
        case "novedadesServicios":
          this.mostrarNovedadesServicios = true;
          await this.$refs.gestionNovedades.cargarDatos();
          break;
        case "gestionPlantExterna":
          this.mostrarGestionPlantExterna = true;
          await this.$refs.gestionPlantExterna.cargarDatos();
          break;
        case "mapaCalor":
          this.mostrarMapaCalor = true;
          break;
        default:
          this.mostrarUltimasNovedades = true;
          break;
      }
    },

    async cargarListas() {
      try {
        const [
          tiposResponse,
          relevanciasResponse,
          subNovedadesGpsResponse,
          subNovedadesRutasResponse,
          novedadesGeocercasResponse,
        ] = await Promise.all([
          axios.get("/api/lista/157"),
          axios.get("/api/lista/149"),
          axios.get("/api/lista/158"),
          axios.get("/api/lista/159"),
          axios.get("/api/lista/225"),
        ]);
        this.listasForms.tiposNovedad = tiposResponse.data;
        this.listasForms.relevancias = relevanciasResponse.data;
        this.listasForms.subNovedadesGps = subNovedadesGpsResponse.data;
        this.listasForms.subNovedadesRutas = subNovedadesRutasResponse.data;
        this.listasForms.subNovedadesGeocercas =
          novedadesGeocercasResponse.data;
      } catch (error) {
        // Error al cargar listas - se maneja silenciosamente
      }
    },

    limpiarFiltros() {
      this.filtros = {
        tipo_novedad: null,
        relevancia: null,
        estado: null,
        per_page: 10,
        tipo_filtro: null,
        entidad_id: null,
      };
      this.getIndex(1);
    },

    limpiarFiltrosExportar() {
      this.filtrosExportar = {
        fecha_inicial: null,
        fecha_final: null,
        tipo_novedad: null,
        tipo_subnovedad: null,
        relevancia: null,
        vehiculo_id: null,
      };
    },

    onCantidadChange() {
      this.getIndex(1);
    },

    // Métodos de sonido
    inicializarAudio() {
      // Solicitar permisos de audio
      if (
        typeof AudioContext !== "undefined" ||
        typeof webkitAudioContext !== "undefined"
      ) {
        this.audioHabilitado = true;
      }
    },

    toggleSonido() {
      if (!this.audioHabilitado) {
        this.$swal({
          icon: "warning",
          title: "Audio no disponible",
          text: "El navegador no soporta audio o no se han otorgado permisos",
        });
        return;
      }

      this.sonidoActivo = !this.sonidoActivo;
    },

    // Métodos de mapa
    actualizarMarcadoresMapa() {
      this.markersNovedades = this.novedades
        .filter((novedad) => novedad.latitud && novedad.longitud)
        .map((novedad) => {
          const estaSeleccionada =
            this.novedadSeleccionada &&
            this.novedadSeleccionada.id === novedad.id;
          return {
            position: {
              lat: parseFloat(novedad.latitud),
              lng: parseFloat(novedad.longitud),
            },
            icon: this.getMarkerIcon(novedad.relevancia, estaSeleccionada),
            novedad: novedad,
          };
        });
    },

    getMarkerIcon(relevancia, estaSeleccionada = false) {
      const iconColors = {
        1: "#ffc107", // Amarillo para advertencia
        2: "#dc3545", // Rojo para emergencia
        3: "#17a2b8", // Azul para media relevancia
      };

      const color = iconColors[relevancia] || "#6c757d";

      // Si está seleccionada, resaltar con borde más grueso, escala mayor y color más brillante
      if (estaSeleccionada) {
        return {
          path:
            "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
          fillColor: color,
          fillOpacity: 1,
          strokeColor: "#000000", // Borde negro para destacar
          strokeWeight: 4, // Borde más grueso
          scale: 2.0, // Marcador más grande
          anchor: { x: 12, y: 24 },
        };
      }

      return {
        path:
          "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.5,
        anchor: { x: 12, y: 24 },
      };
    },

    seleccionarNovedad(novedad) {
      this.novedadSeleccionada = novedad;
      this.buscarRutasTramo(novedad);
      if (novedad.latitud && novedad.longitud) {
        this.mapCenter = {
          lat: parseFloat(novedad.latitud),
          lng: parseFloat(novedad.longitud),
        };
        this.mapZoom = 15;
        // Actualizar los marcadores para resaltar el seleccionado
        this.actualizarMarcadoresMapa();
      }
    },

    async buscarRutasTramo(novedad) {
      let entidad_id = null,
        entidad_type = novedad.entidad_type;

      switch (novedad.entidad_type) {
        case "App\\TepTurno":
          entidad_id = novedad.entidad?.turno_id;
          break;
        case "App\\TepViajes":
          entidad_id = novedad.entidad?.tep_ruta_id;
          break;
        case "App\\TifTurnos":
          entidad_id = novedad.entidad?.tif_ruta_id;
          break;
        default:
          break;
      }

      var url = "/api/tif/centralTrafico/getTramosRutasMapaNovedades";

      axios
        .get(url, { params: { entidad_id, entidad_type } })
        .then((response) => {
          this.tramosRutasMapa = response.data.data;

          this.$nextTick(() => {
            this.construirPolylines(this.tramosRutasMapa);
          });
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    construirPolylines() {
      this.polylines = [];

      if (!this.tramosRutasMapa || !this.tramosRutasMapa.length) return;

      this.tramosRutasMapa.forEach((item) => {
        const tramoRuta = item.tramo_ruta;

        if (!tramoRuta || !tramoRuta.det_tramos_rutas) return;

        // Ordenar por orden
        const puntos = tramoRuta.det_tramos_rutas.sort(
          (a, b) => a.orden - b.orden,
        );

        let path = [];

        puntos.forEach((punto, index) => {
          // Punto inicial
          if (index === 0) {
            path.push({
              lat: parseFloat(punto.lat_ini),
              lng: parseFloat(punto.lon_ini),
            });
          }

          // Punto final
          path.push({
            lat: parseFloat(punto.lat_fin),
            lng: parseFloat(punto.lon_fin),
          });
        });

        this.polylines.push({
          path: path,
          strokeColor: tramoRuta.color || "#FF0000",
          strokeOpacity: 1,
          strokeWeight: 4,
        });
      });
    },

    toggleInfoWindow(marker, index) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = this.generarContenidoInfoWindow(marker.novedad);
      this.infoWindowOpen = true;
    },

    generarContenidoInfoWindow(novedad) {
      const relevanciaColor =
        {
          1: "warning",
          2: "danger",
          3: "info",
        }[novedad.relevancia] || "secondary";

      return `
        <div class="card border-0 shadow-sm" style="max-width: 280px;">
          <div class="card-header bg-primary text-white py-2 px-3">
            <h6 class="mb-0 fw-bold">
              <i class="fas fa-exclamation-triangle me-2"></i>
              ${novedad.nTipoNovedad || "N/A"}
            </h6>
          </div>
          <div class="card-body p-3">
            <div class="d-flex align-items-center mb-2">
              <i class="fas fa-tag text-primary me-2"></i>
              <div class="flex-grow-1">
                <small class="text-muted d-block">Sub Novedad</small>
                <strong class="text-dark">${this.getTipoSubNovedad(
                  novedad,
                )}</strong>
              </div>
            </div>

            <div class="d-flex align-items-center mb-2">
              <i class="fas fa-truck text-primary me-2"></i>
              <div class="flex-grow-1">
                <small class="text-muted d-block">Vehículo</small>
                <strong class="text-dark">${this.getPlacaVehiculo(
                  novedad,
                )}</strong>
              </div>
            </div>
            
            <div class="d-flex align-items-center mb-2">
              <i class="fas fa-user text-info me-2"></i>
              <div class="flex-grow-1">
                <small class="text-muted d-block">Conductor</small>
                <strong class="text-dark">${this.getConductor(novedad) ||
                  "N/A"}</strong>
              </div>
            </div>
            
            <div class="d-flex align-items-center mb-2">
              <i class="far fa-clock text-secondary me-2"></i>
              <div class="flex-grow-1">
                <small class="text-muted d-block">Fecha</small>
                <strong class="text-dark">${this.formatFecha(
                  novedad.fecha_novedad,
                )}</strong>
              </div>
            </div>
            
            <div class="d-flex align-items-center mb-2">
              <i class="fas fa-signal text-${relevanciaColor} me-2"></i>
              <div class="flex-grow-1">
                <small class="text-muted d-block">Relevancia</small>
                <span class="badge bg-${relevanciaColor}">${novedad.nRelevancia ||
        "N/A"}</span>
              </div>
            </div>
            
            ${
              novedad.det_tramo_ruta && novedad.det_tramo_ruta.tramo_ruta
                ? `
            <div class="d-flex align-items-center">
              <i class="fas fa-route text-success me-2"></i>
              <div class="flex-grow-1">
                <small class="text-muted d-block">Tramo</small>
                <strong class="text-dark">${novedad.det_tramo_ruta.tramo_ruta.nombre}</strong>
              </div>
            </div>
                `
                : ""
            }
          </div>
        </div>
      `;
    },

    onMapClick() {
      this.infoWindowOpen = false;
    },

    // Métodos de utilidad
    formatFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },

    getPlacaVehiculo(novedad) {
      if (!novedad) return "N/A";

      const placaEntidad =
        novedad.entidad &&
        novedad.entidad.vehiculo &&
        novedad.entidad.vehiculo.placa;
      if (placaEntidad) return placaEntidad;

      return placaEntidad || "N/A";
    },

    getConductor(novedad) {
      if (!novedad) return "N/A";

      // Buscar conductor en entidad
      if (novedad.entidad && novedad.entidad.conductor) {
        const conductor = novedad.entidad.conductor;
        if (conductor.nombres && conductor.apellidos) {
          return `${conductor.nombres} ${conductor.apellidos}`;
        }
        if (conductor.nombres) return conductor.nombres;
        if (conductor.apellidos) return conductor.apellidos;
      }

      return "N/A";
    },

    getConductorDocumento(novedad) {
      if (!novedad) return "N/A";

      // Buscar documento en entidad
      if (
        novedad.entidad &&
        novedad.entidad.conductor &&
        novedad.entidad.conductor.numero_documento
      ) {
        return novedad.entidad.conductor.numero_documento;
      }

      return "N/A";
    },

    getConductorCelular(novedad) {
      if (!novedad) return "N/A";

      // Buscar celular en det_postulacion
      if (novedad.det_postulacion && novedad.det_postulacion.conductor) {
        const conductor = novedad.det_postulacion.conductor;
        if (conductor.celular_principal) {
          return conductor.celular_principal;
        }
      }

      // Buscar celular en viaje
      if (novedad.viaje && novedad.viaje.conductor) {
        const conductor = novedad.viaje.conductor;
        if (conductor.celular_principal) {
          return conductor.celular_principal;
        }
      }

      // Buscar celular directo
      if (novedad.conductor && novedad.conductor.celular_principal) {
        return novedad.conductor.celular_principal;
      }

      return "N/A";
    },

    getRemolque(novedad) {
      if (!novedad) return null;

      const placaEntidad =
        novedad.entidad &&
        novedad.entidad.remolque &&
        novedad.entidad.remolque.placa;
      if (placaEntidad) return placaEntidad;

      return placaEntidad || null;
    },

    getEmpresa(novedad) {
      if (!novedad) return "Sin transportadora";
      return (
        (novedad.empresa && novedad.empresa.razon_social) ||
        "Sin transportadora"
      );
    },

    getTipoSubNovedad(novedad) {
      if (!novedad) return null;

      switch (novedad.tipo_novedad) {
        case 1:
          return novedad.nSubNovedadGps;
        case 2:
          return novedad.nSubNovedadRuta;
        case 4:
          return novedad.nSubNovedadGeocerca;
      }
      return null;
    },

    getNovedadIcon(tipoNovedad) {
      const iconos = {
        1: "fa-exclamation-triangle", // Advertencia
        2: "fa-exclamation-circle", // Emergencia
        3: "fa-info-circle", // Información
      };
      return iconos[tipoNovedad] || "fa-bell";
    },

    getRelevanciaColor(relevancia) {
      const colores = {
        1: "bg-warning",
        2: "bg-danger",
        3: "bg-info",
      };
      return colores[relevancia] || "bg-secondary";
    },

    // Métodos de exportación
    abrirModalExportar() {
      // Inicializar filtros de exportación con valores por defecto
      this.filtrosExportar = {
        fecha_inicial: moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        fecha_final: moment().format("YYYY-MM-DD"),
        tipo_novedad: null,
        relevancia: null,
      };

      // Mostrar modal
      const modalElement = document.getElementById("modalExportar");
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    exportarNovedades() {
      this.exportando = true;
      const params = {
        ...this.filtrosExportar,
      };
      axios({
        method: "POST",
        url: "/api/tif/centralTrafico/exportNovedades",
        params,
      })
        .then((response) => {
          this.exportando = false;
          let data = response.data;
          if (data.success) {
            //this.$refs.modalExportar.click();
            location.href = data.url;
            this.$swal({
              icon: "success",
              title: data.message,
              text: "El archivo se ha descargado correctamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.$swal({
              icon: "error",
              title: data.message,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
          this.exportando = false;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.exportando = false;
        });
    },

    valFechasExportar() {
      let fechaInicial = moment(this.filtrosExportar.fecha_inicial);
      let fechaFinal = moment(this.filtrosExportar.fecha_final);
      if (
        this.filtrosExportar.fecha_inicial &&
        this.filtrosExportar.fecha_final
      ) {
        if (fechaInicial.isAfter(fechaFinal)) {
          this.$swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "error",
            title: "La fecha inicial no puede ser mayor a la fecha final",
          });
          this.filtrosExportar.fecha_final = null;
        }
      }
    },

    buscarVehiculos(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        axios
          .get("/api/admin/vehiculos/lista", {
            params: {
              linea_negocio_id: [3, 5],
            },
          })
          .then((response) => {
            me.listasForms.vehiculos = response.data;
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
        loading(false);
      }
    },
  },
};
</script>
<style>
.traffic-os {
  background: #1a1d23;
  color: #e0e0e0;
}
.traffic-dashboard {
  overflow-x: hidden;
}

/* Header Central de Tráfico */
.traffic-os-header {
  background: #252830;
  border-bottom: 1px solid #3d424d;
  padding: 0.5rem 1rem;
}
.traffic-os-header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 100%;
}
.traffic-os-logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00d4ff 0%, #0099cc 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 0.5rem;
}
.traffic-os-logo i {
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.7rem;
  position: relative;
  z-index: 0;
}
.traffic-os-logo-p {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 800;
  font-size: 0.8rem;
  line-height: 1;
  z-index: 1;
  text-shadow: 0 0 1px #1a1d23;
}
.traffic-os-brand {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}
.traffic-os-actions .btn-link {
  color: #00d4ff;
  padding: 0.35rem 0.5rem;
}
.traffic-os-actions .btn-link:hover {
  color: #33ddff;
}
</style>
